"use client"
import { motion } from "framer-motion"
import {  Linkedin, Facebook } from "lucide-react"

const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <motion.footer
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="bg-gray-900 text-gray-300 py-8"
    >
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0">
            <h2 className="text-2xl font-bold text-white mb-2">Gennie Tools</h2>
            <p className="text-sm">Your Ultimate Free Online Tool Platform</p>
          </div>
          <div className="flex flex-col items-center md:items-end">
            <p className="text-sm mb-2">
              Created and developed by{" "}
              <a
                href="https://www.amennoomen.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-400 hover:text-blue-300 transition duration-300"
              >
                Amen Allah Naamen
              </a>
            </p>
            <div className="flex space-x-4 mt-2">
              
              <a
                href="https://www.linkedin.com/in/amen-allah-naamen-/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white transition duration-300"
              >
                <Linkedin size={20} />
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=100009878657488"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white transition duration-300"
              >
                <Facebook size={20} />
              </a>
            </div>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-gray-700 text-center text-sm">
          <p>&copy; {currentYear} Gennie Tools. All rights reserved.</p>
        </div>
      </div>
    </motion.footer>
  )
}

export default Footer

